import { useEffect, useState } from "react";
import { Recommendation as RecommendationType } from "../../types";
import { useApiData } from "../../contexts/ApiData";
import Section from "../Section";
import Recommendation from "./Recommendation";
import List from "../List/List";
import styles from "./Recommendations.module.css";

const Recommendations = () => {
  const { get } = useApiData();
  const [ recommendations, setRecommendations ] = useState<RecommendationType[]>([]);
  useEffect(() => {
    const call = async () => {
      const recs = await get(`/recommendations`);
      if (recs) {
        setRecommendations(recs);
      }
    };
    call();
  }, [get]);

  if (recommendations.length === 0) {
    return null;
  }

  return (
    <Section span={8}>
      <List className={styles.list} items={recommendations.map((r, index) => (
        <Recommendation recommendation={r} key={`${r.surveyId}_${index}`} />
      ))}/>
    </Section>
  );
};

export default Recommendations;
